/** The card step (`src/components/payment`): sheet, leave guard, Stripe errors. */
export const fr = {
  eyebrow: 'Paiement sécurisé · Stripe',
  title: 'Pré-autorisez votre carte',
  held: 'pré-autorisés, pas débités',
  checking: 'Vérification…',
  submit: 'Pré-autoriser {amount}',
  amountToday: "Montant pré-autorisé aujourd'hui",
  fx: 'Votre carte est débitée en {currency}, au taux de Cardnd du moment : c’est ce montant exact qui est bloqué.',
  fxBalance: 'Le solde à l’agence se règle en MAD.',
  reassurance:
    '<b>Votre carte est pré-autorisée, pas débitée.</b> Le débit a lieu quand une agence confirme ; sinon la pré-autorisation est libérée.',
  processedBy: 'Paiement traité par Stripe. Vos coordonnées bancaires ne transitent jamais par Cardnd.',
  configUnavailable:
    'Le paiement en ligne est momentanément indisponible. Votre réservation est conservée : réessayez dans un instant.',
  stripeUnavailable:
    'Le formulaire de paiement sécurisé n’a pas pu se charger (paiement indisponible). Vérifiez votre connexion, puis réessayez : votre réservation est conservée.',
  formUnavailable:
    'Le formulaire de carte n’a pas pu se charger (paiement indisponible). Fermez cette fenêtre et réessayez dans un instant : votre réservation est conservée.',
  'demo.title': 'Mode démonstration',
  'demo.text': 'Aucune carte n’est demandée ni débitée : le formulaire Stripe s’affiche ici avec le vrai serveur.',
  'leave.eyebrow': 'Paiement en attente',
  'leave.title': 'Quitter sans payer ?',
  'leave.leave': 'Quitter',
  'leave.stay': 'Rester',
  'leave.text':
    'Votre réservation est enregistrée mais pas encore pré-autorisée : aucune agence ne la reçoit tant que la carte n’est pas validée. Vous la retrouverez pendant un temps limité dans Mes voyages, onglet « À payer ».',
  /* Flow errors */
  noSecret: 'Le paiement en ligne n’a pas pu démarrer. Votre réservation est conservée : réessayez dans un instant.',
  expired: 'Ce paiement n’est plus valable. Relancez la pré-autorisation : votre réservation est conservée.',
  createFailed: 'La réservation n’a pas pu être créée. Réessayez dans un instant.',
  /* Stripe errors (codes mapped to our wording) */
  'card.declined': 'Votre carte a été refusée. Essayez une autre carte ou contactez votre banque.',
  'card.insufficientFunds': 'Fonds insuffisants sur cette carte. Essayez une autre carte.',
  'card.expired': 'Cette carte a expiré. Utilisez une autre carte.',
  'card.cvc': 'Le code de sécurité (CVC) est incorrect.',
  'card.number': 'Le numéro de carte est incorrect.',
  'card.expiry': 'La date d’expiration est incorrecte.',
  'card.processing': 'La banque n’a pas pu traiter la carte. Réessayez dans un instant.',
  'card.authentication':
    'La vérification de votre banque (3-D Secure) n’a pas abouti. Réessayez ou utilisez une autre carte.',
  'card.invalid': 'Vérifiez les informations de la carte.',
  'card.unavailable': 'Paiement momentanément indisponible. Réessayez dans un instant.',
  'card.failed': 'Le paiement n’a pas abouti. Réessayez.',
  'status.processing': 'Votre banque traite encore le paiement. Patientez un instant, puis vérifiez dans Mes voyages.',
  'status.canceled': 'Ce paiement a été annulé. Relancez la pré-autorisation.',
  'status.failed': 'Le paiement n’a pas abouti. Réessayez ou utilisez une autre carte.',
} as const;
